import BaseCtrl from 'edge/platform/base/BaseCtrl';

function updatePropertyIncidents(incidents, locations) {
    const newIncidentList = [];
    incidents.value.forEach(incident => {
        if (locations.some(location => location.number === incident.location)) {
            newIncidentList.push(incident);
        }
    });
    locations.forEach(location => {
        if (!incidents.value.some(incident => location.number === incident.location)) {
            newIncidentList.push({
                location: location.number
            });
        }
    });
    incidents.value = newIncidentList;
}

const fn = ($scope, claimViewModel) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.claimVm = claimViewModel();
        $scope.propertyIncidentsVm = $scope.claimVm.lobs.commercialProperty.fixedPropertyIncidents;
        $scope.cpPolicyExtension = $scope.claimVm.policy.lobs.commercialProperty.value;

        updatePropertyIncidents($scope.propertyIncidentsVm, $scope.cpPolicyExtension.locations);
    };

    ctrl.next = (nextFn) => {
        nextFn($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel'];

export default fn;